import React from 'react';
import styles from './gift-presentation.module.css';
import { useViewModel } from './useViewModal';

export function GiftPresentation() {
  const { onClose, giftInfo, formatPrice } = useViewModel();
  if (!giftInfo) return null;
  const { title, price, imageUrl, description } = giftInfo;
  return (
    <div className={styles['giftPresentation__overlay']} onClick={onClose} role="presentation">
      <div
        className={styles['giftPresentation__modal']}
        role="dialog"
        aria-modal="true"
        aria-labelledby="gift-presentation-title"
        aria-describedby="gift-presentation-description"
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles['giftPresentation__header']}>
          <h2 id="gift-presentation-title" className={styles['giftPresentation__title']}>
            {title}
          </h2>
          <span className={styles['giftPresentation__price']}>{formatPrice({ amount: price })}</span>
          <button className={styles['giftPresentation__close']} onClick={onClose} aria-label="Close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        <div className={styles['bagPresentation__content']}>
          <div className={styles['bagPresentation__image']}>
            <img src={imageUrl} alt={title} />
          </div>

          <div id="gift-presentation-description" className={styles['bagPresentation__description']}>
            <div
              className={styles['bagPresentation__description-text']}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </div>
        </div>

        <button className="button button--secondary button--black button--full-width" onClick={onClose}>
          CLOSE
        </button>
      </div>
    </div>
  );
}
